import Skeleton from '../Skeleton';
import SkeletonGroup from '../SkeletonGroup';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SkeletonText: FunctionComponent<Props> = ({
    className = '',
    gap = 'sm',
    lines = 3,
    testId = TEST_ID,
    width
}) => {
    const safeLines = Math.max(1, lines);

    return (
        <SkeletonGroup
            className={`${styles.text} ${className}`}
            direction='column'
            gap={gap}
            testId={testId}>
            {Array.from({ length: safeLines }).map((_, index) => {
                const lineWidth =
                    width ?? (index === safeLines - 1 ? '60%' : index === 0 ? '100%' : '80%');

                return <Skeleton key={index} variant='text' width={lineWidth} />;
            })}
        </SkeletonGroup>
    );
};

export default SkeletonText;
